import {NavigationDropdown} from '../components'

const taxonomy = {
	graphs: {
		items: {
			financial: {to: '/data/graphs/financial'},
			leads: {to: '/data/graphs/leads'},
		},
	},
	map: {to: '/data/map'},
	api_consumers: {to: '/api_consumers'},
}

export const Data = () => <NavigationDropdown name="data" taxonomy={taxonomy} />
